import Phaser from "phaser";

/**
 * 画面上部の小型ツールバー。auto / skip / log / save / load / config のボタン。
 */
export interface TopBarHandlers {
  onAuto: () => void;
  onSkip: () => void;
  onBacklog: () => void;
  onSave: () => void;
  onLoad: () => void;
  onConfig: () => void;
  onTitle: () => void;
}

export class TopBar {
  private container: Phaser.GameObjects.Container;
  private buttons = new Map<string, Phaser.GameObjects.Rectangle>();
  private labels = new Map<string, Phaser.GameObjects.Text>();

  constructor(scene: Phaser.Scene, handlers: TopBarHandlers) {
    const w = scene.scale.width;
    this.container = scene.add.container(0, 0);

    const items: Array<{ key: string; label: string; onClick: () => void }> = [
      { key: "auto", label: "AUTO", onClick: handlers.onAuto },
      { key: "skip", label: "SKIP", onClick: handlers.onSkip },
      { key: "log", label: "LOG", onClick: handlers.onBacklog },
      { key: "save", label: "SAVE", onClick: handlers.onSave },
      { key: "load", label: "LOAD", onClick: handlers.onLoad },
      { key: "config", label: "CONFIG", onClick: handlers.onConfig },
      { key: "title", label: "TITLE", onClick: handlers.onTitle },
    ];

    const btnW = 76;
    const btnH = 28;
    const gap = 6;
    const totalW = items.length * btnW + (items.length - 1) * gap;
    const startX = w - totalW - 14;

    items.forEach((item, i) => {
      const x = startX + i * (btnW + gap) + btnW / 2;
      const y = 22;
      const bg = scene.add
        .rectangle(x, y, btnW, btnH, 0x252535, 0.85)
        .setStrokeStyle(1, 0x66aaff)
        .setInteractive({ useHandCursor: true });
      const lbl = scene.add
        .text(x, y, item.label, {
          fontFamily: "system-ui, sans-serif",
          fontSize: "13px",
          color: "#cce6ff",
        })
        .setOrigin(0.5);
      bg.on("pointerover", () => bg.setFillStyle(0x3a3a55, 1.0));
      bg.on("pointerout", () => bg.setFillStyle(0x252535, 0.85));
      bg.on("pointerdown", () => item.onClick());
      this.container.add([bg, lbl]);
      this.buttons.set(item.key, bg);
      this.labels.set(item.key, lbl);
    });
  }

  setActive(key: string, active: boolean): void {
    const lbl = this.labels.get(key);
    const bg = this.buttons.get(key);
    if (!lbl || !bg) return;
    if (active) {
      lbl.setColor("#ffdd66");
      bg.setStrokeStyle(2, 0xffdd66);
    } else {
      lbl.setColor("#cce6ff");
      bg.setStrokeStyle(1, 0x66aaff);
    }
  }

  setVisible(v: boolean): void {
    this.container.setVisible(v);
  }
}
